import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BundleLoaderService } from './bundle-loader/bundle-loader.service';

@Injectable({ providedIn: 'root' })
export class BundlePreloadService {
  private loaded = false;

  constructor(private bundleLoader: BundleLoaderService) {}

  preloadRealtimeTrainDetails() {
    if (this.loaded) return;
    const urls = environment?.appConfig?.webComponents?.realtimeTrainDetails;
    if (urls && !customElements.get('csxwc-realtime-train-details')) {
      urls.forEach(url => this.bundleLoader.loadBundle(url));
      this.loaded = true;
    }
  }
}
